module.exports = __webpack_public_path__ + "static/media/sun.acb87989.png";